/* eslint-disable */
import React from 'react';
import ReactDOM from 'react-dom';
import App from '../react/ExternalLinkEditor';

class ExternalLinkEditor {
    constructor() {
        this.container = document.querySelector('#ExternalLinkEditor');

        if (this.container) {
            ReactDOM.render(<App />, document.getElementById('ExternalLinkEditor'));
        }
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {

    }
}

export default ExternalLinkEditor;